import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import CustomSurveyReportApi from 'apis/reports/CustomSurveyReport';
import CustomSurveyList from 'components/businesses/tabs/reports/CustomSurveyList';
import CustomSurveyReport from 'components/businesses/tabs/reports/CustomSurveyReport';
import 'assets/scss/questions.css';

class BusinessReport extends Component {
  constructor() {
    super();
    this.state = {
      customSurveyReport: [],
      startDate: null,
      endDate: null,
    };

    this.changeReportRange = this.changeReportRange.bind(this);
    this.fetchCustomSurveyReport = this.fetchCustomSurveyReport.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { startDate, endDate } = this.state;
    if (location !== prevProps.location) {
      if (startDate && endDate)
        this.fetchCustomSurveyReport(startDate.unix(), endDate.unix());
      else this.fetchCustomSurveyReport();
    }
  }

  changeReportRange(startDate, endDate) {
    if (
      (this.state.startDate || this.state.endDate) &&
      !startDate &&
      !endDate
    ) {
      this.fetchCustomSurveyReport();
    }

    this.setState(
      (state, props) => {
        return {
          startDate,
          endDate,
        };
      },
      () => {
        if (startDate && endDate) {
          this.fetchCustomSurveyReport(startDate.unix(), endDate.unix());
        }
      }
    );
  }

  fetchCustomSurveyReport(from, to) {
    if (this.props.match.params.customSurveyId) {
      CustomSurveyReportApi.getAll(
        this.props.match.params.customSurveyId,
        from,
        to
      )
        .then(({ data }) => {
          this.setState({ customSurveyReport: data });
        })
        .catch(e => console.log(e));
    }
  }

  render() {
    const { customSurveyReport, startDate, endDate } = this.state;
    const { match } = this.props;
    const { customSurveyId } = match.params;
    const customSurveyReportList = (
      <CustomSurveyReport
        collapseReport={false}
        match={match}
        report={customSurveyReport}
        fetchReport={this.fetchCustomSurveyReport}
        changeReportRange={this.changeReportRange}
        startDate={startDate}
        endDate={endDate}
      />
    );

    const reportsDisplay = customSurveyId ? (
      customSurveyReportList
    ) : (
      <div className="question-welcome">Select a survey to view Survey Reports</div>
    );

    return (
      <div className="questions-container">
        <Row>
          <Col xs="12" md="3">
            <CustomSurveyList />
          </Col>
          <Col xs="12" md="9">
            {reportsDisplay}
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(BusinessReport);



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/reports/BusinessReport.js